import type {
  CodeableConcept,
  Practitioner,
  Reference,
  Task,
} from '@medplum/fhirtypes'
import { addDays } from 'date-fns'
import type { Order } from '#src/models/orders/index.ts'
import { TASK_TYPES } from '#src/models/tasks/constants.ts'
import { StandardTask } from '#src/models/tasks/standard/standardTask.ts'
import { Role } from '#src/roles.ts'

export class AppointmentRecordRetrievalTask extends StandardTask {
  static defaultRoles = [Role.MA, Role.LVN]

  constructor({
    order,
    owner,
    encounterCompleted,
    ...rest
  }: Partial<Omit<Task, 'resourceType'>> & {
    order: Order
    owner?: Reference<Practitioner>
    encounterCompleted: Date | string
  }) {
    super({
      code: AppointmentRecordRetrievalTask.code,
      priority: 'routine',
      focus: order.reference,
      owner,
      ...rest,
    })
    this.title = 'Appointment Record Retrieval'
    this.description = 'Retrieve appointment records'
    this.state = 'todo'
    this.participant = order.participant
    this.dueOn = addDays(encounterCompleted, 7).toISOString()
  }

  setDueDate(encounterCompleted: Date | string): void {
    this.dueOn = addDays(encounterCompleted, 7).toISOString()
  }

  static get code(): CodeableConcept {
    return TASK_TYPES.APPOINTMENT_RECORD_RETRIEVAL
  }
}
